
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestparaquatlawyers",
      function () {
        return require("private-next-pages/bestparaquatlawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestparaquatlawyers"])
      });
    }
  